/** @jsxImportSource @emotion/react */
import { FEATURE_FLAGS } from '@app/app-constants'
import { useFeatureFlags } from '@app/hooks/useFeatureFlags'
import { Box } from '@mui/material'
import React from 'react'
import { riskLayoutContentWrapperStyle } from './RiskLayout.style'
import RiskNavbar from './RiskNavBar'
type RiskLayoutProps = { children?: React.ReactNode }

export const RiskLayout = ({ children }: RiskLayoutProps) => {
  const { useFeatureFlag } = useFeatureFlags()
  const isT3Enabled = useFeatureFlag(FEATURE_FLAGS.RISK_PROFILE_T3)

  return (
    <Box>
      {isT3Enabled ? null : <RiskNavbar />}
      <Box css={riskLayoutContentWrapperStyle}>{children}</Box>
    </Box>
  )
}

export default RiskLayout
